<template lang="pug">
.ghost-btn(@click="$emit('clicked')")
  .copy {{copy}}
  
  
</template>
<script>
export default {
  name: 'GhostBtn',
  props: {
    copy: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.ghost-btn
  width: pxToRem(175)
  height: pxToRem(60)
  position: relative
  border-radius: pxToRem(30)
  border: 1px $cl-blue solid
  //text-align: center
  //line-height: pxToRem(50)
  display: flex
  align-items: center
  justify-content: center
  margin-right: pxToRem(40)
  .copy
    font-size: 12px
    color: $cl-blue
    position: relative
    top: -1px
</style>
